/**
 *
 *  Workout type Selector
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 13/03/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useState, useCallback, useRef } from "react";
import PropTypes from "prop-types"; // use directly

import { useAppState } from "../../../state";

const WorkoutListItem = ({
  className,
  disabled,
  checked,
  id,
  name,
  item,
  onChange,
}) => {
  const handleChange = useCallback(() => {
    onChange && onChange(item);
  }, [item, onChange]);

  return (
    <div
      className={`${className ? " " + className : ""}`}
      onClick={handleChange}
    >
      <input
        type="radio"
        name={name}
        id={id}
        checked={checked}
        aria-checked={checked}
        // onChange={handleChange}
      />
      <label htmlFor={id} className="tbk-flex tbk-pl-5">
        <div className="tbk-text-main tbk-text-primary">{item.name}</div>
      </label>
    </div>
  );
};

export const BookingFlowWorkoutTypeSelector = ({
  id,
  disabled,
  isFetching,
  workoutValues,
  workout,
  skipLocationCheck,
  onWorkoutChange,
  onSubmit,
}) => {
  const [workoutType, setWorkoutType] = useState(workout);

  const {
    partnerSummary,
    // bookingLocation: location,
    // sessionType,
  } = useAppState();

  const formRef = useRef();

  const locationAvailable = useCallback(() => {
    return true;
  }, []);

  const handleSubmit = useCallback(() => {
    if (!locationAvailable() && !skipLocationCheck) {
      return;
    }

    onSubmit && onSubmit();
  }, [skipLocationCheck, locationAvailable, onSubmit]);

  const handleWorkoutChange = useCallback(
    (val) => {
      setWorkoutType(val);

      // Pass through callback to parent
      onWorkoutChange && onWorkoutChange(val);
    },
    [onWorkoutChange]
  );

  return (
    <form
      ref={formRef}
      name="directBookingForm"
      className="booking-flow-workout-selector tbk-mb-[86px]"
      onSubmit={handleSubmit}
    >
      <div className="direct-booking-form-body tbk-py-3 tbk-px-2">
        <div className="tbk-text-cta tbk-mb-1 tbk-uppercase">
          Choose a discipline
        </div>
        <div className="tbk-text-main tbk-mb-5 tbk-text-primary">
          Choose a discipline for your session with {partnerSummary.firstName}.
          Every session will last 60 minutes.
        </div>
        <div className="tbk-mb-3">
          {workoutValues &&
            workoutValues.map((val, i) => (
              <WorkoutListItem
                key={val.id}
                disabled={false}
                id={`workoutSelector${i}`}
                name="workoutSelector"
                className="tbk-cursor-pointer tbk-rounded-lg tbk-py-1.5 tbk-px-1 hover:tbk-bg-grey-light"
                checked={workoutType && workoutType.id === val.id}
                item={val}
                onChange={handleWorkoutChange.bind(null, val)}
              />
            ))}
        </div>
      </div>
    </form>
  );
};

BookingFlowWorkoutTypeSelector.propTypes = {
  id: PropTypes.string,
  disabled: PropTypes.bool,
  isFetching: PropTypes.bool,
  skipLocationCheck: PropTypes.bool,
  workout: PropTypes.object,
  location: PropTypes.object,
  workoutValues: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  onWorkoutChange: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default BookingFlowWorkoutTypeSelector;
